import Box from "@material-ui/core/esm/Box";
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'components/DatePicker/DatePicker';
import { Select } from 'components/Form';
import generatePeriodStages from 'utils/date/generatePeriodStages';
import useStyles from './PeriodFilterStyles';
export default function PeriodFilter({
  onChange,
  useUtc,
  inline
}) {
  const {
    t
  } = useTranslation();
  const [isCustomPeriod, setIsCustomPeriod] = useState(false);
  const {
    grid,
    column
  } = useStyles();
  const periods = [{
    label: t('datepicker.period_labels.all'),
    value: 'all',
    dateFrom: null,
    dateTo: null
  }, {
    label: t('datepicker.period_labels.thirty_days'),
    value: '30Days',
    dateFrom: dayjs().subtract(1, 'month'),
    dateTo: dayjs()
  }, {
    label: t('datepicker.period_labels.custom_defined'),
    value: 'custom',
    dateFrom: null,
    dateTo: null
  }];
  const [defaultItem] = periods;

  // Extends the periods list with montly choices (July 2020, June 2020 etc) for x months back
  periods.push(...generatePeriodStages({
    months: 6,
    useUtc: true
  }));
  const handleChange = input => {
    const pickedPeriod = periods.find(({
      value
    }) => input === value);
    if (!pickedPeriod) return;
    if (pickedPeriod?.value === 'custom') {
      setIsCustomPeriod(true);
      return;
    }
    setIsCustomPeriod(false);
    onChange({
      startDate: pickedPeriod.dateFrom,
      endDate: pickedPeriod.dateTo
    });
  };
  const mappedItems = periods.map(({
    value,
    label
  }) => ({
    value,
    label
  }));
  if (inline) return /*#__PURE__*/React.createElement("div", {
    className: grid
  }, /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(Select, {
    defaultItem: defaultItem.value,
    id: "select-period",
    label: t('datepicker.show_period'),
    onChange: handleChange,
    items: mappedItems
  })), isCustomPeriod && /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: onChange,
    useUtc: useUtc
  })));
  return /*#__PURE__*/React.createElement(Box, {
    my: 3,
    textAlign: "left"
  }, /*#__PURE__*/React.createElement(Select, {
    defaultItem: defaultItem.value,
    id: "select-period",
    label: t('datepicker.show_period'),
    onChange: handleChange,
    items: mappedItems
  }), isCustomPeriod && /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: onChange,
    useUtc: useUtc
  })));
}
PeriodFilter.defaultProps = {
  useUtc: false,
  inline: false
};